import { createApi } from '@reduxjs/toolkit/query/react'
import { isAxiosError } from 'axios'
import cruxAxios from '../../app/cruxAxios'
import { AD_PLATFORM_TYPE } from '../../features/crux/cruxConstants'
import { NOTIFICATION_SIZE } from '../../features/myInfo/Notification'

const axiosBaseQuery = () => async urlOrConfig => {
  try {
    const response = await (typeof urlOrConfig === 'string'
      ? cruxAxios.get(urlOrConfig)
      : cruxAxios.request(urlOrConfig))
    return { data: response?.data }
  } catch (axiosError) {
    return {
      error: isAxiosError(axiosError)
        ? {
            status: axiosError.response?.status,
            data: axiosError.response?.data,
          }
        : {},
    }
  }
}
export const cruxApi = createApi({
  reducerPath: 'cruxApi',
  tagTypes: ['Tracks', 'NotificationSettings'],
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getTrackInfo: builder.query({
      query: ({ trackId, adAccountId }) =>
        `/bcon/v2/services/keywordad/track-rights/adaccount/${adAccountId}/${trackId}/info`,
      providesTags: (_result, _error, { trackId }) => [
        {
          type: 'Tracks',
          id: trackId,
        },
      ],
    }),
    getNotificationSettings: builder.query({
      query: ({ dspAccountId, page }) => ({
        url: `/crux-account/dspAccounts/${dspAccountId}/notificationSettings:Page`,
        params: {
          adPlatformTypes: AD_PLATFORM_TYPE,
          size: NOTIFICATION_SIZE,
          page,
        },
      }),
      providesTags: (_result, _error, { dspAccountId }) => [
        {
          type: 'NotificationSettings',
          id: dspAccountId,
        },
      ],
    }),
    putNotificationSettings: builder.mutation({
      query: ({ dspAccountId, adAccountIds, notificationSettings }) => ({
        method: 'PUT',
        url: `/crux-account/dspAccounts/${dspAccountId}/adAccounts/${adAccountIds}/notificationSettings`,
        data: notificationSettings,
        headers: {
          adAccountIds,
        },
      }),
      invalidatesTags: (_result, _error, { dspAccountId }) => [
        {
          type: 'NotificationSettings',
          id: dspAccountId,
        },
      ],
    }),
  }),
})
export const {
  useGetTrackInfoQuery,
  useGetNotificationSettingsQuery,
  usePutNotificationSettingsMutation,
} = cruxApi
